import { TagGroup } from "./tagGroup.model";

export class Tags {
  id: number;
  name : string;
  tagGroupId: number;
  color: string | null;
  tagGroup: TagGroup | null;
  constructor() {
    this.id = 0;
    this.name = "";
    this.tagGroupId = 0;
    this.color = null;
    this.tagGroup = null;
  }
}


